import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/surface-area-calculator',
  component: () => import('../../routes/SurfaceArea.svelte'),
  card: {
    id: 'surface-area-calculator',
    title: 'Surface Area Calculator',
    description: 'Calculate the total surface area of geometric shapes including sphere, cylinder, cone, cube, and rectangular prism.',
    icon: 'grid_on',
    iconBgClass: 'bg-violet-50',
    iconTextClass: 'text-violet-600',
    href: '/surface-area-calculator',
    category: 'Conversion & Math',
  },
  seo: {
    title: 'Surface Area Calculator – Calculate SA of Sphere, Cylinder, Cone, Cube',
    description: 'Free surface area calculator. Calculate total surface area of a sphere, cylinder, cone, cube, or rectangular prism. Enter dimensions in inches, feet, cm, meters and more.',
  },
};

export default meta;
